'use client'
import type { FC } from 'react'
import { useMemo } from 'react'
import { blogPostSlug } from 'shared-utils/utils'
import type { StorefrontWidget, SummaryBoxesWidgetType, WidgetBlog } from 'ecosystem'
import type { SummaryBoxesWidgetHandlerProps } from '../../widgets'
import { SummaryBoxesWidgetHandler } from '../../widgets'

export interface IBlogPostsProps {
  widgets: StorefrontWidget<WidgetBlog>[]
  pagePath?: string
  customComponents?: {
    SummaryBoxesWidgetHandler?: FC<SummaryBoxesWidgetHandlerProps>
  }
}

const BlogPosts: FC<IBlogPostsProps> = ({ widgets, customComponents }) => {
  const mappedToSummaryBoxes: StorefrontWidget<SummaryBoxesWidgetType>[] = useMemo(() => {
    return widgets.map((widget, index) => ({
      ...widget,
      widget: {
        ...widget.widget,
        variant: 'VARIANT_1',
        title: '',
        items: [
          {
            name: widget.widget.name,
            order: widget.order,
            title: widget.widget.title,
            sub: widget.widget.summary,
            imgUrl: widget.widget.imgUrl,
            tag: widget.widget.author,
            id: widget.widget.id,
            pathObj: {
              id: '',
              slug: blogPostSlug(widget.widget.slug),
              type: 'blog'
            },
            isReversed: index % 2 === 0
          }
        ]
      }
    }))
  }, [widgets])

  const SummaryBoxesWidgetHandlerComponent =
    customComponents?.SummaryBoxesWidgetHandler || SummaryBoxesWidgetHandler

  return (
    <>
      {mappedToSummaryBoxes.map((w) => (
        <SummaryBoxesWidgetHandlerComponent
          key={w.id}
          sx={{
            '.summary-boxes__item_overlay': {
              display: 'none'
            }
          }}
          widget={w}
          widgetId={w.widget.name}
        />
      ))}
    </>
  )
}

export default BlogPosts
